import React from 'react';
import PropTypes from 'prop-types';
import {Card} from 'antd';
import dayjs from 'dayjs';
import styles from './index.module.less';

const {Meta} = Card;

export default function MeetingCard({meeting}) {
    let {meetingtype, topic, starttime, endtime, address, remarks, status} = meeting;
    return (
        <Card
            className={styles.card}
            bordered={false}
            title={
                <div className={styles.title}>
                    {meetingtype === 101 ? '发起会议邀请消息' : '处理会议邀请消息'}
                </div>
            }
        >
            <Meta title={<div className={styles.topic}>{topic}</div>} />
            <div className={styles.content}>
                <p>
                    开始时间
                    <span className={styles.value}>
                        {dayjs(parseInt(starttime) * 1000).format('YYYY.MM.DD HH:mm')}
                    </span>
                </p>
                <p>
                    结束时间
                    <span className={styles.value}>
                        {dayjs(parseInt(endtime) * 1000).format('YYYY.MM.DD HH:mm')}
                    </span>
                </p>
                <p>
                    会议地址
                    <span className={styles.value}>{address || '暂无'}</span>
                </p>
                <p>
                    会议备注
                    <span className={styles.value}>{remarks || '暂无'}</span>
                </p>
                {status === 1 && <p>处理状态:参加会议</p>}
                {status === 2 && <p>处理状态:拒绝会议</p>}
                {status === 3 && <p>处理状态:待定</p>}
                {status === 4 && <p>处理状态:未被邀请</p>}
                {status === 5 && <p>处理状态:会议已取消</p>}
                {status === 6 && <p>处理状态:会议已过期</p>}
                {status === 7 && <p>处理状态:不在房间内</p>}
            </div>
        </Card>
    );
}

MeetingCard.propTypes = {
    meeting: PropTypes.object.isRequired,
};
